/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-down': {
    width: 12,
    height: 7,
    viewBox: '0 0 12 7',
    data: '<path pid="0" d="M12 .503a.501.501 0 0 1-.147.355L6.355 6.355a.502.502 0 0 1-.71 0L.147.857a.502.502 0 1 1 .71-.71L6 5.29 11.143.147A.502.502 0 0 1 12 .503z" _fill="#616161" fill-rule="nonzero"/>'
  }
})
